const INTEREST_RATE = 2.29;

export function calculateInterest(total, months) {
  if (months === 1) return total;
  const interest = INTEREST_RATE / 100 + 1;

  return total * interest;
}
